import { RestaurantCatalogCategory } from "./RestaurantCatalogCategory";

export default RestaurantCatalogCategory;
